module.exports = __webpack_public_path__ + "assets/BackBtn.422b70dc3f7e2a8220212e54851f670a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/levels/BackBtn.svg
// module id = 185
// module chunks = 0